import BreedSelector from './BreedSelector'

export default BreedSelector
